/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {FurnitureModel} from '../../../furniture/models'
import Swal from 'sweetalert2'
import {deleteFurnitureService} from '../../../furniture/services/deleteFurniture.service'
import {enqueueSnackbar} from 'notistack'
import {getFurnitureService} from '../../../furniture/services/getFurnitures.service'
import {Column} from 'react-table'
import {ModalUpdateFurniture} from '../Modal/ModalUpdateFurniture'
import {ModalNewFurniture} from '../Modal/ModalNewFurniture'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableFurniture: FC = () => {
  const {data, setData, setPagination, loading, setLoading, selected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [showModalNew, setShowModalNew] = useState(false)
  const [furnitureToEdit, setFurnitureToEdit] = useState<FurnitureModel | any>(null)

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getFurnitures()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getFurnitures()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getFurnitures = async () => {
    setLoading(true)
    const {data: response} = await getFurnitureService({
      ModuloId: currentTabItem.idToEdit,
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
    })
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const mappedSelected = selected.map((item) => ({Id: item}))
        const {data: response} = await deleteFurnitureService(mappedSelected)
        if (!response.error) {
          getSnackBarToast('Se eliminó satisfactoriamente', 'sucess')
          getFurnitures()
        } else {
          getSnackBarToast(response.message, 'error')
        }
        getFurnitures()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  const handleEdit = (item: FurnitureModel) => {
    setShowModalUpdate(true)
    setFurnitureToEdit(item)
  }

  const columns: Column<FurnitureModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Código de Mobiliario' />,
      accessor: 'Codigo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Mobiliario' />,
      accessor: 'TipoMobiliario_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Descripción Mobiliario' />,
      accessor: 'Descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'Observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('MOBILIARIO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  return (
    <>
      {isAllowed('MOBILIARIO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('MOBILIARIO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('MOBILIARIO/ELIMINAR') && (
              <button
                className='btn btn-primary me-3'
                disabled={selected.length < 1}
                onClick={handleDelete}
                type='button'
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModalUpdate ? (
            <ModalUpdateFurniture
              show={showModalUpdate}
              setShow={setShowModalUpdate}
              furnitureToEdit={furnitureToEdit}
              getFurnitures={getFurnitures}
            />
          ) : (
            <></>
          )}
          {showModalNew ? (
            <ModalNewFurniture
              show={showModalNew}
              setShow={setShowModalNew}
              getFurnitures={getFurnitures}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableFurnitureFromRoomWrapper = () => {
  return (
    <KTableProvider>
      <TableFurniture />
    </KTableProvider>
  )
}
export {TableFurnitureFromRoomWrapper}
